import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {SpecChooserComponent} from "@webmate-web-core/shared/components/specs/spec-chooser.component";
import {TreeSelectModule} from "primeng/treeselect";
import {FormsModule} from "@angular/forms";
import {ButtonModule} from "primeng/button";
import {Tree} from "primeng/tree";

@NgModule({
    declarations: [
        SpecChooserComponent,
    ],
    imports: [CommonModule, FontAwesomeModule, TreeSelectModule, FormsModule, ButtonModule, Tree],
    exports: [
        SpecChooserComponent,
    ]
})
export class SpecsSharedModule { }
